// extracted by mini-css-extract-plugin
export default {"info":"info__-Vw0R","info_time":"info_time__WWmin","info_amount":"info_amount__f8ZSk","info_status":"info_status__5w9ko","first_i":"first_i__AzmeZ","end_i":"end_i__K-aub"};